export default {
    data() {
        return {
            tableGBoptions: {
                options: { editar: 'Editar Razón social', inactivar: 'Inactivar Razón Social' },
                modals: []
            },

            tableGBSearch: ['datos_razon/name'],

            tableGBItems: [{
                    thead: { th: 'Documento', sort: null, sortTable: 'datos_razon/documento' },
                    tbody: { td: ['list_documento/name', 'datos_razon/documento'], }
                },
                {
                    thead: { th: 'Razón', sort: null, sortTable: 'datos_razon/name' },
                    tbody: { td: ['datos_razon/name'], }
                },
                {
                    thead: { th: 'ARL', },
                    tbody: { td: ['list_arl/name'], }
                },
                {
                    thead: { th: 'CCF', },
                    tbody: { td: ['list_ccf/name'], }
                },
                {
                    thead: { th: 'Teléfonos', },
                    tbody: { td: ['datos_razon/telefonos'], }
                },
                {
                    thead: { th: 'Email', },
                    tbody: { td: ['datos_razon/email'], }
                },
            ]
        }
    },
}